import '@tensorflow/tfjs-backend-webgl';
import * as mpHands from '@mediapipe/hands';
import * as handdetection from '@tensorflow-models/hand-pose-detection';

export class HandEstimation {
  constructor(model, options) {
    this.model = handdetection.SupportedModels.MediaPipeHands;
    this.modelConfig = {maxPoses: 1, type: 'full', scoreThreshold: 0.65, render3D: false}
    this.backend = options.pose.backend
  }

  async createDetector() {
    switch (this.model) {
      case handdetection.SupportedModels.MediaPipeHands:
        const runtime = this.backend.split('-')[0];
        if (runtime === 'mediapipe') {
          this.detector = await handdetection.createDetector(this.model, {
            runtime,
            modelType: this.modelConfig.type,
            maxHands: this.modelConfig.maxNumHands,
            solutionPath: `https://cdn.jsdelivr.net/npm/@mediapipe/hands@${mpHands.VERSION}`
          });
        } else if (runtime === 'tfjs') {
          this.detector = await handdetection.createDetector(this.model, {
            runtime,
            modelType: this.modelConfig.type,
            maxHands: this.modelConfig.maxNumHands
          });
        }
    }
  }

  async estimatePoses(image) {
    if (!this.detector) {
      return
    }

    try {
      return await this.detector.estimateHands(image, {flipHorizontal: false});
    } catch (e) {
      // this.detector.dispose();
      this.detector = null;
      // alert(error);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/common/HandEstimation.js